import * as types from "../actions/actionTypes";
import initialState from "./initialState";

export default function vehicleReducer(state = initialState.vehicle, action) {
  // let newData = null; // code clean up
  // let newDate2 = null; // code clean up
  switch (action.type) {
    case types.LOAD_VEHICLE_SUCCESS:
      return action.vehicle;
    case types.UPDATE_VEHICLE_SUCCESS:
      return state.map((vehicle) =>
        vehicle.vehicleId === action.vehicle.vehicleId
          ? action.vehicle
          : vehicle
      );
    case types.SAVE_VEHICLE_SUCCESS:
      return state.map((vehicle) =>
        vehicle.vehicleId === action.vehicle.vehicleId
          ? action.vehicle
          : vehicle
      );
    case types.ADD_VEHICLE_SUCCESS:
      if (state.some((v) => v.vehicleId === action.vehicle.vehicleId)) {
        /* vehicle already exists */
        return [...state];
      } else {
        return [...state, { ...action.vehicle }];
      }
    default:
      return state;
  }
}
